let _myPath = `${process.env.BASE_URL}static/images`
let roleDetails = {
	"menke": [
		{
            "name":"織田信長",
            "read":"",
            "introduce":"幼名は吉法師。尾張国の戦国大名。織田弾正忠家の当主・織田信秀の子として生まれた。戦国時代から安土桃山時代にかけての武将，戦国大名で、三英傑の一人である。",
            "img":`${_myPath}/menke/detail/menke_detail_01.png`,
            "img_pifu":""
        },
        {
            "name":"劉邦",
            "read":"りゅう･ほう",
            "introduce":"前漢の初代皇帝。沛県の亭長であったが、反秦連合に参加した後に秦の都咸陽を陥落させ、一時は関中を支配下に入れた。その後項羽によって西方の漢中へ左遷され漢王となるも、東進して垓下に項羽を討ち、前漢を興した。",
            "img":`${_myPath}/menke/detail/menke_detail_02.png`,
            "img_pifu":""
        },
        {
            "name":"霍去病",
            "read":"かく・きょへい",
            "introduce":"衛青の甥で、騎射に優れており、18歳で衛青に従って匈奴征伐に赴いている。その後も何度も匈奴征伐に功績を拳げ、3万の首を上げた。衛青と並んで大司馬とされた。",
            "img":`${_myPath}/menke/detail/menke_detail_03.png`,
            "img_pifu":""
        },
        {
            "name":"司馬懿",
            "read":"しば・い",
            "introduce":"後漢末期から三国時代曹魏にかけての武将・政治家。魏において功績を立て続けて大権を握り、西晋の礎を築いた人物。字は仲達（ちゅうたつ）。西晋が建てられると、廟号を高祖、諡号を宣帝と追号された。『三国志』では司馬宣王と表記されている。",
            "img":`${_myPath}/menke/detail/menke_detail_04.png`,
            "img_pifu":""
        },
        {
            "name":"チンギス・カン",
            "read":"チンギス・カン",
            "introduce":"大小様々な集団に分かれてお互いに抗争していたモンゴルの遊牧民諸部族を一代で統一し、中国・中央アジア・イラン・東ヨーロッパなどを次々に征服し、最終的には当時の世界人口の半数以上を統治するに到る人類史上最大規模の世界帝国であるモンゴル帝国の基盤を築き上げた。",
            "img":`${_myPath}/menke/detail/menke_detail_05.png`,
            "img_pifu":""
        },
        {
            "name":"始皇帝",
            "read":"しこうてい",
            "introduce":"中国戦国時代の秦王。姓は嬴（えい）、氏は趙（ちょう）、諱は政（せい）。紀元前221年に史上初の中国統一を成し遂げると最初の皇帝となり、紀元前210年に49歳で死去するまで君臨した。中国統一を成し遂げた後に「始皇帝」と名乗った。歴史上の重要な人物であり、約2000年に及ぶ中国皇帝の先駆者である。",
            "img":`${_myPath}/menke/detail/menke_detail_06.png`,
            "img_pifu":"",
        },
        {
            "name":"徳川家康",
            "read":"",
            "introduce":"戦国時代から安土桃山時代にかけての武将である。江戸幕府の初代征夷大将軍。織田信長、豊臣秀吉と共に、その功績の大きさから「三英傑」と称された。",
            "img":`${_myPath}/menke/detail/menke_detail_07.png`,
            "img_pifu":`${_myPath}/menke/detail/menke_pifu_07.png`
        },
        {
            "name":"宮本武蔵",
            "read":"",
            "introduce":"江戸時代初期の剣術家、兵法家。二天一流の開祖である。剣豪とも呼ばれている。剣術の奥義をまとめて「五輪書」という著作をこの世に伝わった。",
            "img":`${_myPath}/menke/detail/menke_detail_08.png`,
            "img_pifu":`${_myPath}/menke/detail/menke_pifu_08.png`
        },
        {
            "name":"伊達政宗",
            "read":"",
            "introduce":"伊達氏の第17代当主。近世大名としては仙台籓の初代籓主である。幼い時に患った疱瘡により、右目を失明した。そして後世になって「独眼竜」という異名があった。",
            "img":`${_myPath}/menke/detail/menke_detail_09.png`,
            "img_pifu":`${_myPath}/menke/detail/menke_pifu_09.png`
        },
        {
            "name":"劉備",
            "read":"りゅう･び",
            "introduce":"劉備、三国時代における優れた政治家、軍略家。彼は民を愛し、人材を重用し、度量が大きく意志も強くて、心が広い。蜀漢王朝の初代皇帝である。",
            "img":`${_myPath}/menke/detail/menke_detail_10.png`,
            "img_pifu":""
        },
        {
            "name":"ガルダン",
            "read":"ガルダン",
            "introduce":"オイラ卜部族連合に属するジュンガル部の第4代部族長および第3代ホンタイジ（皇太子）である。1685年にはアンディジャンに遠征し、瞬く間に中央アジアを征服していった。",
            "img":`${_myPath}/menke/detail/menke_detail_11.png`,
            "img_pifu":""
        },
        {
            "name":"衛青",
            "read":"えい・せい",
            "introduce":"爵位は長平侯である。初出征は竜城の奇襲で、匈奴征討で連戦連勝して匈奴の首を数万討ち取り、匈奴の領土奪い取るなど、多大な功績を挙げる。",
            "img":`${_myPath}/menke/detail/menke_detail_12.png`,
            "img_pifu":""
        },
        {
            "name":"発丘将軍",
            "read":"はっきゅう・しょうぐん",
            "introduce":"「発丘天官（はっきゅう・てんかん）」とも称される。曹操が設立した盗掘組織の官職である。邪気ばらいのためにいつも専用の銅印を身につけているという。",
            "img":`${_myPath}/menke/detail/menke_detail_13.png`,
            "img_pifu":""
        },
        {
            "name":"王羲之",
            "read":"おう・ぎし",
            "introduce":"中国東晋の政治家、書家でもある。魏晋南北朝時代を代表する門閥貴族、琅邪王氏の出身である。",
            "img":`${_myPath}/menke/detail/menke_detail_14.png`,
            "img_pifu":""
        },
        {
            "name":"荊軻",
            "read":"けい・か",
            "introduce":"戦国時代の有名な暗殺者である。始皇帝を刺殺失敗して犠牲した。",
            "img":`${_myPath}/menke/detail/menke_detail_15.png`,
            "img_pifu":""
        },
        {
            "name":"司馬遷",
            "read":"しぱ・せん",
            "introduce":"「史記」の著者で、中国前漢時代の歴史家である。姓は司馬。名は遷、字は子長。太初暦の制定や、通史「史記」の執筆などの業績がある。",
            "img":`${_myPath}/menke/detail/menke_detail_16.png`,
            "img_pifu":""
        },
        {
            "name":"王安石",
            "read":"おう・あんせき",
            "introduce":"北宋の政治家であり、詩人や文章家でもある。字は介甫、号は半山。文章家として有名で、仁宗皇帝に上奏した「万言書」は名文として称えられ、唐宋八大家の一人だと称されている。",
            "img":`${_myPath}/menke/detail/menke_detail_17.png`,
            "img_pifu":""
        },
        {
            "name":"杜甫",
            "read":"と・ほ",
            "introduce":"中国盛唐の詩人である。「杜少陵」「杜工部」とも呼ばれる。幼い頃から詩文を書く才能があり、李白と共に、中国の文字史上にて最高の詩人と言われている。",
            "img":`${_myPath}/menke/detail/menke_detail_18.png`,
            "img_pifu":""
        },
        {
            "name":"孫武",
            "read":"そん・ぶ",
            "introduce":"中国古代の春秋時代の武将であり、有名な軍事思想家で、兵家の代表的な人物。有名な著作『孫子』の作者である。",
            "img":`${_myPath}/menke/detail/menke_detail_19.png`,
            "img_pifu":""
        },
        {
            "name":"蘇軾",
            "read":"そ・しょく",
            "introduce":"宋王朝における有名な文学家、書道家そして画家である。",
            "img":`${_myPath}/menke/detail/menke_detail_20.png`,
            "img_pifu":""
        },
        {
            "name":"高漸離",
            "read":"こう・ぜんり",
            "introduce":"中国の戦国時代の音楽家と名士で、始皇帝を刺殺失敗した荊軻の親友である。",
            "img":`${_myPath}/menke/detail/menke_detail_21.png`,
            "img_pifu":""
        },
        {
            "name":"東方朔",
            "read":"とうぼう・さく",
            "introduce":"漢王朝における有名な文学家である。",
            "img":`${_myPath}/menke/detail/menke_detail_22.png`,
            "img_pifu":""
        },
        {
            "name":"蘇秦",
            "read":"そ・しん",
            "introduce":"戦国時代の有名な軍師家、外交家と謀略家である。",
            "img":`${_myPath}/menke/detail/menke_detail_23.png`,
            "img_pifu":""
        },
        {
            "name":"李白",
            "read":"り・はく",
            "introduce":"唐王朝における最も有名な詩人で、「詩人仙」とも言われている。お酒が好きて、剣術もとても強いとのことである。",
            "img":`${_myPath}/menke/detail/menke_detail_24.png`,
            "img_pifu":""
        },
        {
            "name":"李廣",
            "read":"り・こう",
            "introduce":"中国前漢時代の将軍。文帝・景帝・武帝に仕える人物。飛将軍という名で世間に知られる。武勇に優れていたが戦功をみとめられることなく憤死した。",
            "img":`${_myPath}/menke/detail/menke_detail_25.png`,
            "img_pifu":""
        },
        {
            "name":"胡雪岩",
            "read":"こ・せつがん",
            "introduce":"清朝にいた有名な大金持ちである。清朝の末期に杭州で起業し、上海にまで広げた。官商として巨万の富を得る一方、清朝政府に対する功績が認められる。後世になってその憧れの一人だとされている。",
            "img":`${_myPath}/menke/detail/menke_detail_26.png`,
            "img_pifu":""
        },
        {
            "name":"張廷玉",
            "read":"ちょう・ていぎょく",
            "introduce":"清朝の政治家である。保和殿大学士、軍機大臣、大保の位を得て、三等伯に封ぜられ、三朝にわたって50年も仕えた偉い人物。",
            "img":`${_myPath}/menke/detail/menke_detail_27.png`,
            "img_pifu":""
        },
        {
            "name":"索尼",
            "read":"ソニン",
            "introduce":"清朝初期の重臣で、満州正黃旗出身であり、二等子の爵位と一等公を与えられた。漢文満州話、モンゴル語に通じていたので、通訳としても重要な役割を担った。",
            "img":`${_myPath}/menke/detail/menke_detail_28.png`,
            "img_pifu":""
        },
        {
            "name":"納蘭明珠",
            "read":"のうらん・めいしゅ",
            "introduce":"清の詩人、学者で、優れた詩を書いたことによって知られる。進士に及第し、康熙帝の側近として働いた。",
            "img":`${_myPath}/menke/detail/menke_detail_29.png`,
            "img_pifu":""
        },
        {
            "name":"周培公",
            "read":"しゅう・ぱいこう",
            "introduce":"名は昌で、字は培公である。湖北省荊門の出身。康熙帝の側近であり、重要な謀臣の一人で、三藩の乱を鎮圧した将軍の一人である。",
            "img":`${_myPath}/menke/detail/menke_detail_30.png`,
            "img_pifu":""
        },
        {
            "name":"干将",
            "read":"かんしょう",
            "introduce":"中国史上有名な刀匠である。戦国時代の帝王に刀剣を鍛冶したこともある。名剣「干将」と「莫邪」は彼が鍛冶されたのである。",
            "img":`${_myPath}/menke/detail/menke_detail_31.png`,
            "img_pifu":""
        },
        {
            "name":"張衡",
            "read":"ちょう・こう",
            "introduce":"中国漢王朝の偉大な天文学家、数学家、発明家、地理学家と文学家である。地震を感知することができる「地動儀」は彼の最も有名な発明である。",
            "img":`${_myPath}/menke/detail/menke_detail_32.png`,
            "img_pifu":""
        },
        {
            "name":"歐陽修",
            "read":"おうよう・しゅう",
            "introduce":"宋王朝における有名な政治家と文学家である。",
            "img":`${_myPath}/menke/detail/menke_detail_33.png`,
            "img_pifu":""
        },
        {
            "name":"范文程",
            "read":"はん・ぶんてい",
            "introduce":"清王朝初期の四名の帝王を補佐した歴史上の名臣である。清王朝の制度の多くは彼が制定されたので、文臣の頂点とも言われている。",
            "img":`${_myPath}/menke/detail/menke_detail_34.png`,
            "img_pifu":""
        },
        {
            "name":"李衛",
            "read":"り・えい",
            "introduce":"清王朝の名臣で、三人の帝王を補佐していた。その才能は皇帝に深く評価された。",
            "img":`${_myPath}/menke/detail/menke_detail_35.png`,
            "img_pifu":""
        },
        {
            "name":"曹雪芹",
            "read":"そう・せつきん",
            "introduce":"清王朝における大文学家で、代表作は中国史上の四大名著の中の「紅楼夢」である。",
            "img":`${_myPath}/menke/detail/menke_detail_36.png`,
            "img_pifu":""
        },
        {
            "name":"洪承疇",
            "read":"こう・じょうちゅう",
            "introduce":"洪承疇、中国明末清初の官僚・武将である。明の対清戦線の総責任者として防衛を指揮したが、後に清朝に降伏した。帰順後は明朝の政治制度を移植して清朝の統治機構の基礎を構築し、南明征伐も指揮した。",
            "img":`${_myPath}/menke/detail/menke_detail_37.png`,
            "img_pifu":""
        },
        {
            "name":"年羮尭",
            "read":"ねん・こうよう",
            "introduce":"清の康熙・雍正期の官人である。太保に任じられ、また一等公爵に封じられた。撫遠大将軍としてチベットに遠征する。",
            "img":`${_myPath}/menke/detail/menke_detail_38.png`,
            "img_pifu":""
        },
        {
            "name":"林則徐",
            "read":"りん・そくじょ",
            "introduce":"清代の官僚、政治家、思想家または詩人であり、欽差大臣を２回務めている。イギリスによる阿片密輸の取り締まりを強行した第一人者であるため、民族英雄と呼ばれている。",
            "img":`${_myPath}/menke/detail/menke_detail_39.png`,
            "img_pifu":""
        },
        {
            "name":"華安",
            "read":"か・あん",
            "introduce":"もともとは太師府内の書童で、文武両道に通じる。",
            "img":`${_myPath}/menke/detail/menke_detail_40.png`,
            "img_pifu":`${_myPath}/menke/detail/menke_pifu_40.png`
        },
        {
            "name":"簫剣",
            "read":"しょう・けん",
            "introduce":"本名は方厳で、子供の時から行方不明になった妹をずっと探している。武技が強い剣士である。",
            "img":`${_myPath}/menke/detail/menke_detail_41.png`,
            "img_pifu":`${_myPath}/menke/detail/menke_pifu_41.png`
        },
        {
            "name":"紀昀",
            "read":"き・いん",
            "introduce":"清王朝の政治家と文学家である。兵部、礼部の尚書を務めるたことがあり、中国史上有名な賢者である。",
            "img":`${_myPath}/menke/detail/menke_detail_42.png`,
            "img_pifu":`${_myPath}/menke/detail/menke_pifu_42.png`
        },
        {
            "name":"劉墉",
            "read":"りゅう・よう",
            "introduce":"清王朝の政治家、書道家、そして大学士である。その清廉潔白さと公正さで後世に名を残している。",
            "img":`${_myPath}/menke/detail/menke_detail_43.png`,
            "img_pifu":`${_myPath}/menke/detail/menke_pifu_43.png`
        },
        {
            "name":"鄭板橋",
            "read":"てい・ばんきょう",
            "introduce":"清王朝の政治家、文学家と画家である。科挙を三回参加して、それぞれ秀才、挙人そして進士となった。政界を離れた後、楊州で画家として暮らしていた。",
            "img":`${_myPath}/menke/detail/menke_detail_44.png`,
            "img_pifu":`${_myPath}/menke/detail/menke_pifu_44.png`
        },
        {
            "name":"陳近南",
            "read":"ちん・きんなん",
            "introduce":"清王朝と対抗する民間組織「天地会」のリーダーである。生涯は清王朝を転覆して明王朝を復興するために努めていた。",
            "img":`${_myPath}/menke/detail/menke_detail_45.png`,
            "img_pifu":""
        }
    ],
    "wuhu":[
        {
            "name":"趙雲",
            "read":"ちょう・うん",
            "introduce":"三国志の登場人物。正史においては、官民の義勇兵を率いて公孫賛の配下となる。そして、公孫賛の配下として各地を転戦。 その道中、公孫賛が青州において袁紹と戦っている田楷の援軍として劉備を派遣した際に随行し、劉備の騎兵隊長となった。 五虎上将の翊軍将軍。",
            "img":`${_myPath}/wuhu/detail/wuhu_detail_01.png`,
            "img_pifu":""
        },
        {
            "name":"馬超",
            "read":"ば・ちょう",
            "introduce":"三国志の登場人物。関中の独立軍閥の長の座を父から引き継ぎ、曹操に服属していたが、後に韓遂と共に曹操に反乱を起こして敗れた。一族も勢力も失い流浪した末、益州の劉備の下に身を寄せ、厚遇を受けた。五虎上将の左将軍。",
            "img":`${_myPath}/wuhu/detail/wuhu_detail_02.png`,
            "img_pifu":""
        },
        {
            "name":"黄忠",
            "read":"こう・ちゅう",
            "introduce":"三国志の登場人物。正史においては、元々は荊州を治めていた劉表の武将であった。その後、劉備が漢中攻めを行なう際に夏侯淵が率いる部隊と戦って勝利を収めた。これを足掛かりに漢中王になった劉備が黄忠を後将軍に任命し翌年に死去した。五虎上将の後将軍。",
            "img":`${_myPath}/wuhu/detail/wuhu_detail_03.png`,
            "img_pifu":""
        },
        {
            "name":"張飛",
            "read":"ちょう・ひ",
            "introduce":"三国志の登場人物。後漢末の群雄の一人である劉備の挙兵に当初から付き従った人物で、その人並み外れた勇猛さは下述の通り中原に轟いた。その武勇は後世にも称えられた。五虎上将の右将軍。",
            "img":`${_myPath}/wuhu/detail/wuhu_detail_04.png`,
            "img_pifu":""
        },
        {
            "name":"関羽",
            "read":"かん・う",
            "introduce":"三国志の登場人物。漢の創始者である劉備に仕え、その人並み外れた武勇や義理を重んじた彼は敵の曹操や多くの同時代人から称賛された。後漢から贈られた封号は漢寿亭侯。諡が壮繆侯だが、諡号は歴代王朝から多数贈られた。五虎上将の前将軍。",
            "img":`${_myPath}/wuhu/detail/wuhu_detail_05.png`,
            "img_pifu":""
        },
       
    ],
    "wuyi":[
        {
            "name":"呉用",
            "read":"ご・よう",
            "introduce":"中国の小説で四大奇書の一つである『水滸伝』の登場人物。綽名は智多星。天下に並びない智謀の持ち主で、軍師として神算鬼謀の限りを尽くした。しかし、諸葛亮のような神懸り的な人物ではなく、失敗もすれば冗談も飛ばす人間的な人物である。天機星の生まれ変わりで、序列は梁山泊第三位の好漢。",
            "img":`${_myPath}/wuyi/detail/wuyi_detail_01.png`,
            "img_pifu":""
        },
        {
            "name":"公孫勝",
            "read":"こうそん・しょう",
            "introduce":"中国の小説で四大奇書の一つである『水滸伝』の登場人物。修行中の道士であり、その道術でたびたび梁山泊軍の危機を救う。かなりの長身で体格のよい偉丈夫とされる。梁山泊では副軍師を務める。天間星の生まれ変わりで、序列は梁山泊第四位の好漢",
            "img":`${_myPath}/wuyi/detail/wuyi_detail_02.png`,
            "img_pifu":""
        },
        {
            "name":"林冲",
            "read":"りん・ちゅう",
            "introduce":"中国の小説で四大奇書の一つである『水滸伝』の登場人物。善良で深く傷を負った心を持つ好漢や、欲望が命取りになった特権階級の若い男性、息子を守るために正義を欺く汚職で腐敗した高官の話などとと もに、尊ばれていた紳士が好漢としての運命をたどる。天雄星の生まれ変わりで、序列は梁山泊第六位の好漢。",
            "img":`${_myPath}/wuyi/detail/wuyi_detail_03.png`,
            "img_pifu":""
        },
        {
            "name":"宋江",
            "read":"そう・こう",
            "introduce":"北宋末の1121年に現在の山東省近辺で反乱を起こした人物。四大叛徒の一人。また、その反乱事件に題材にした小説で中国の四大奇書の一つである『水滸伝』では主人公となっている。天魁星の生まれ変わりで、天魁星・呼保義の宋江、あるいは山東の及時雨と呼ばれる。梁山泊の好漢百八人中の序列第一位の好漢。",
            "img":`${_myPath}/wuyi/detail/wuyi_detail_04.png`,
            "img_pifu":""
        },
        {
            "name":"盧俊義",
            "read":"ろ・しゅんぎ",
            "introduce":"介绍：中国の小説で四大奇書の一つである『水滸伝』の登場人物。渾名は玉麒麟で、風采・人格・気品が備わっていることに由来する。人品優れるとは説明されながら、作中では自己中心的で頑迷な性格の目立つ人物である。天罡星の生まれ変わりで、序列は梁山泊第二位の好漢。",
            "img":`${_myPath}/wuyi/detail/wuyi_detail_05.png`,
            "img_pifu":""
        }
    ],
    "nvjie":[
        {
            "name":"井伊 直虎",
            "read":"いい なおとら",
            "introduce":"戦国時代頃の遠江井伊谷の領主である。「井伊直虎」という名の人物についての同時代史料によると、江戸時代に書かれた井伊氏の家伝で、井伊家当主になったと記載された井伊直盛の娘で、次郎法師と同一人物とされる。",
            "img":`${_myPath}/nvjie/detail/nvjie_detail_01.png`,
            "img_pifu":""
        },
        {
            "name":"鶴姫",
            "read":"つるひめ",
            "introduce":"大山祇神社（愛媛県大三島）の大祝安用の娘といい、戦国時代の伊予にいたとされる伝承上の女性である。生涯はたびたび大三島に侵攻した周防の大内氏の軍勢と交戦してこれを撃退するも、最後は戦死した恋人の後を追って自殺したという一説もある。",
            "img":`${_myPath}/nvjie/detail/nvjie_detail_02.png`,
            "img_pifu":""
        },
        {
            "name":"花木蘭",
            "read":"か･もくらん",
            "introduce":"老病の父に代わり、娘の木蘭が男装して従軍する。異民族（主に突厥）を相手に各地を転戦し、刀をさげて戦場に駆けつける勇猛有名な女武将だと知られている。",
            "img":`${_myPath}/nvjie/detail/nvjie_detail_03.png`,
            "img_pifu":""
        },
        {
            "name":"雑賀孫市",
            "read":"さいか まごいち",
            "introduce":"雑賀衆、雑賀党鈴木氏の棟梁や有力者が代々継承する名前である。雑賀孫一と「孫市」という名でも知られる。鉄砲を数千挺も取り揃えた傭兵集団「雑賀衆」の頭領として活躍した。",
            "img":`${_myPath}/nvjie/detail/nvjie_detail_04.png`,
            "img_pifu":""
        },
        {
            "name":"穆桂英",
            "read":"ぼく·けいえい",
            "introduce":"『楊家将演義』題材とした登場する架空の人物である。穆柯寨に住む山賊一人娘で、楊家一員となった。宋朝、金に抵抗して戦った女英雄の名女将軍として記録されている。",
            "img":`${_myPath}/nvjie/detail/nvjie_detail_05.png`,
            "img_pifu":""
        }
    ],
    "jiancheng":[
        {
            "name":"趙 高",
            "read":"ちょう·こう",
            "introduce":"中国古代秦の宦官で、政治家である。秦帝国を私物化して、保身のため忠臣を謀殺するに足らず皇帝をも殺して、天下万民からも恨みを買い帝国滅亡の原因となった趙高は、悪臣の象徴として後世でも引き合いに出されている。",
            "img":`${_myPath}/jiancheng/detail/jiancheng_detail_01.png`,
            "img_pifu":`${_myPath}/jiancheng/detail/jiancheng_pifu_01.png`, 
        },
        {
            "name":"魏忠賢",
            "read":"ぎ·ちゅう けん",
            "introduce":"中国明朝の宦官である。皇帝を傀儡にして実権を握り恐怖政治を敷いた最も悪辣な宦官の権力者であって、すでに危機的状況にあった明の滅亡を加速させた。",
            "img":`${_myPath}/jiancheng/detail/jiancheng_detail_02.png`,
            "img_pifu":`${_myPath}/jiancheng/detail/jiancheng_pifu_02.png`, 
        },
        {
            "name":"李蓮英",
            "read":"り·れんえい",
            "introduce":"中国清朝末期最後の宦官である。19世紀後半、悪の宦官として最高位に登り詰めて権力を振った。西太后に忠誠を尽くして、彼女の寵愛を受けて、宮廷内で大権力を持ち宦官（大太監）である。",
            "img":`${_myPath}/jiancheng/detail/jiancheng_detail_03.png`,
            "img_pifu":`${_myPath}/jiancheng/detail/jiancheng_pifu_03.png`, 
        },
        {
            "name":"秦 檜",
            "read":"しん·かい",
            "introduce":"中国南宋の宰相である。金との講和を進め和議を結ぶが、その過程において岳飛ら政府人員を謀殺して、また自らの権力保持のために敵国の金の圧力を背景に恐怖政治を敷いたので、後世、その名は売国奴となり蔑まれた。",
            "img":`${_myPath}/jiancheng/detail/jiancheng_detail_04.png`,
            "img_pifu":`${_myPath}/jiancheng/detail/jiancheng_pifu_04.png`, 
        }
    ],
    "meiren":[
        {
            "name":"陳円円",
            "read":"ちん･えんえん",
            "introduce":"中国明代末期の美妓。秦淮八艶の一人。明末清初に活躍した軍閥武将呉三桂の妾（側室）。本姓は邢、諱は沅。字は畹芬。叛将呉三桂の心を奪った傾国の美女といわれ、その生涯は多くの伝説で包まれている。",
            "img":`${_myPath}/meiren/detail/meiren_detail_01.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_01.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"貂蝉",
            "read":"ちょうせん",
            "introduce":"後漢の司徒・王允の養女であり、王允に仕えた歌姫。歌舞に優れており、その容姿は演義に登場する女性の中でも1、2を争うほどの絶世の美女として描かれている。 ",
            "img":`${_myPath}/meiren/detail/meiren_detail_02.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_02.png`, 
            "img_pifu":`${_myPath}/meiren/detail/meiren_pifu_02.png`, 
            "img_pifu_chongai":`${_myPath}/meiren/detail/meiren_pifuchongai_02.png`, 
        },
        {
            "name":"董小宛",
            "read":"とう･しょうえん",
            "introduce":"明末南京の名妓。秦淮八絶という、当時南京で有名だった八人の妓女にも列挙されている。戦乱の中、恋人の冒辟疆と離散を繰り返した。",
            "img":`${_myPath}/meiren/detail/meiren_detail_03.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_03.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"胡青羊",
            "read":"こ･せいよう",
            "introduce":"倚天屠龍記での人物で、可愛がるが武力がよわい。神医胡青牛の妹である。",
            "img":`${_myPath}/meiren/detail/meiren_detail_04.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_04.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"花見羞",
            "read":"か･けんしゅう",
            "introduce":"中国五代十国後唐の美人で、二代目明宗皇帝李嗣源の寵妃である。五代の第一美人と呼ばれる。",
            "img":`${_myPath}/meiren/detail/meiren_detail_05.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_05.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"金香玉",
            "read":"きん･こうぎょく",
            "introduce":"宿屋の看板娘。活発でかわいい。賢妻の手元である。",
            "img":`${_myPath}/meiren/detail/meiren_detail_06.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_06.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"李霊児",
            "read":"り･れいじ",
            "introduce":"兵部尚書李政道の娘で、京城で有名の美人である。",
            "img":`${_myPath}/meiren/detail/meiren_detail_07.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_07.png`, 
            "img_pifu":`${_myPath}/meiren/detail/meiren_pifu_07.png`, 
            "img_pifu_chongai":`${_myPath}/meiren/detail/meiren_pifuchongai_07.png`
        },
        {
            "name":"李師師",
            "read":"り･しし",
            "introduce":"北宋末期の美妓で、徽宗の妃嬪でもある。靖康元年、金軍が開封を陥落させた際、混乱により行方不明となった。変装して逃亡したと考えるのが通説であるが、自殺したあるいは出家したとも言われた。",
            "img":`${_myPath}/meiren/detail/meiren_detail_08.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_08.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"林黛玉",
            "read":"りん・たいぎょく",
            "introduce":"宝玉の従妹で幼なじみ。字は顰児。詩才と機知に富む一方病弱で繊細。厭世的で悲観的かつ神経質で極めて感受性の強い美少女。宝玉が好きだがプライドが高いためか素直になれない。",
            "img":`${_myPath}/meiren/detail/meiren_detail_09.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_09.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"柳如是",
            "read":"りゅう･にょぜ",
            "introduce":"明末清初の芸妓・詩人で、詩や書の才能を開花させ、当時の文人たちにも高く評価されたという人物です。特に陳子龍との恋愛関係が知られるが、成就しなかった。その後、有名な銭謙益の側室となる。",
            "img":`${_myPath}/meiren/detail/meiren_detail_10.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_10.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"呂雉",
            "read":"りょ･ち",
            "introduce":"漢の高祖劉邦の皇后である。謚は高皇后。夫・劉邦の死後、皇太后・太皇太后となり、呂后、呂太后、呂妃とも呼ばれる。「中国三大悪女」として唐代の武則天（則天武后）、清代の西太后と共に名前が挙げられる。",
            "img":`${_myPath}/meiren/detail/meiren_detail_11.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_11.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"双児",
            "read":"そう･じ",
            "introduce":"金庸の武俠小説、『鹿鼎記』に登場する架空の人物。韋小宝の妻の一人となる。穏やかで控えめな性格。変わり者ぞろいの韋小宝の妻の中では比較的地味な方であり、自分が目立つのではなく陰ながら韋小宝をサポートすることが多い。",
            "img":`${_myPath}/meiren/detail/meiren_detail_12.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_12.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"蘇小小",
            "read":"そ･しょうしょう",
            "introduce":"中国東晋朝代の才色兼備の美人で、裕福な家庭に生まれた。小柄で可愛いらしいので、「小小」と名前をつけた。貴族の男性と恋愛して、後でふられて、毎日悲しくてかなしくて死んでしまった。死後は西湖の「西泠橋畦」に墓を残った。",
            "img":`${_myPath}/meiren/detail/meiren_detail_13.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_13.png`, 
            "img_pifu":`${_myPath}/meiren/detail/meiren_pifu_13.png`, 
            "img_pifu_chongai":`${_myPath}/meiren/detail/meiren_pifuchongai_13.png`
        },
        {
            "name":"王昭君",
            "read":"おう･しょうくん",
            "introduce":"荊州南郡出身で、古代中国四大美人の一人に数えられる。似顔絵師の仕業で王昭君をわざと醜く描いたから、皇帝と会う機会がなくなった。後、似顔絵の中から一番醜い女性である王昭君を選び、匈奴の妻として差し出し、別れ儀式に現れると元帝は目を見張った。それは似顔絵全然似つかなく絶世の美女だった。地団駄踏んで悔しがったが、約束を撤回できない。",
            "img":`${_myPath}/meiren/detail/meiren_detail_14.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_14.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"武則天",
            "read":"ぶ･そくてん",
            "introduce":"中国史上唯一の女帝である。唐の高宗の皇后となり、後に唐に代わり武周朝を建てた。幼名を媚娘と名付けられたという、現在の中国では姓を冠して「武媚娘」と呼ぶことが一般的になっている。",
            "img":`${_myPath}/meiren/detail/meiren_detail_15.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_15.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"西施",
            "read":"せいし",
            "introduce":"本名は施夷光で、中国では西子ともいう。紀元前5世紀、春秋時代末期の浙江省紹興市諸曁県生まれだと言われている。四大美女としての画題となると、彼女が川で足を出して洗濯をする姿に見とれて魚達は泳ぐのを忘れてしまったという俗説から「沈魚美人」とあてられる。",
            "img":`${_myPath}/meiren/detail/meiren_detail_16.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_16.png`, 
            "img_pifu":`${_myPath}/meiren/detail/meiren_pifu_16.png`, 
            "img_pifu_chongai":`${_myPath}/meiren/detail/meiren_pifuchongai_16.png`
        },
        {
            "name":"欣寧",
            "read":"きんねい",
            "introduce":"姓は愛新覚羅、名は欣寧である。清の時代の姫で、雍親王の愛娘である。父親に溺愛されているため、わがままばかりである。",
            "img":`${_myPath}/meiren/detail/meiren_detail_17.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_17.png`, 
            "img_pifu":`${_myPath}/meiren/detail/meiren_pifu_17.png`, 
            "img_pifu_chongai":`${_myPath}/meiren/detail/meiren_pifuchongai_17.png`
        },
        {
            "name":"徐鶯鶯",
            "read":"じょ･えいえい",
            "introduce":"私塾徐才子の娘である。父親の影響の下で教養があって礼儀正しくて、そして美しい。",
            "img":`${_myPath}/meiren/detail/meiren_detail_18.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_18.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"薛宝釵",
            "read":"せつ･ほうさ",
            "introduce":"宝玉の従姉。頭脳明晰、人格円満、優等生タイプの少女。実は冷淡な性格で他人と距離を置くようになった。詩も学問も人に優れてよくできるが、それらが女性にとって価値があるものとは思っていない。",
            "img":`${_myPath}/meiren/detail/meiren_detail_19.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_19.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"楊貴妃",
            "read":"よう･きひ",
            "introduce":"中国唐代の皇妃で玄宗皇帝の寵姫である。姓は楊、名は玉環。貴妃は皇妃としての順位を表す称号。玄宗皇帝が寵愛しすぎたために安史の乱を引き起こしたと伝えられたため、傾国の美女と呼ばれる。",
            "img":`${_myPath}/meiren/detail/meiren_detail_20.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_20.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"長平姫",
            "read":"ちょうへい・ひめ",
            "introduce":"明の時代の姫で、明の最後の皇帝である崇禎帝の娘である。生母は身分が低くしかも早世したため、周皇后に育てられた。崇禎17年、長平姫その時16歳時、明の時代は滅亡した。",
            "img":`${_myPath}/meiren/detail/meiren_detail_21.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_21.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"趙飛燕",
            "read":"ちょう･ひえん",
            "introduce":"前漢成帝の皇后である。その出生は卑賤であり、幼少時に長安にたどり着き、歌舞の研鑽を積み、その美貌が成帝の目にとまり後宮に迎え、後宮では成帝の寵愛を受け、さらに妹の趙合徳を昭儀として入宮されることも実現した。成帝は趙飛燕を皇后とすることを計画し、前18年に許皇后を廃立し、前16年に立后が実現した。",
            "img":`${_myPath}/meiren/detail/meiren_detail_22.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_22.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"趙合徳",
            "read":"ちょう･ごうとく",
            "introduce":"趙飛燕の妹である。姉と共に帝の寵愛を集めるが、宮中に召される際もまた入った後も姉を立て続けて、気が強く我儘な姉とは対象的に控えめな態度で姉を懐柔して、巧妙な手練手管で帝を虜にして昭儀という地位にまで上りった。",
            "img":`${_myPath}/meiren/detail/meiren_detail_23.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_23.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"趙小須",
            "read":"ちょう･しょうしゅ",
            "introduce":"冤罪で流刑された趙文宣知府の娘で、垢抜けした美貌を持つ。だが家は貧乏の一途を辿ってきたため、いつも冷淡である。",
            "img":`${_myPath}/meiren/detail/meiren_detail_24.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_24.png`, 
            "img_pifu":`${_myPath}/meiren/detail/meiren_pifu_24.png`, 
            "img_pifu_chongai":`${_myPath}/meiren/detail/meiren_pifuchongai_24.png`
        },
        {
            "name":"祝英台",
            "read":"しゅく･えいたい",
            "introduce":"中国江南の悲恋物語の主人公である。男装の祝英台と遊学中親友となって、のち祝英台が女性と知って愛情をいだくが他に嫁すことになり梁山伯は焦がれ死んだ。花嫁の行列が彼の墓にさしかかると墓が裂けて祝英台はとび込んでしまう。",
            "img":`${_myPath}/meiren/detail/meiren_detail_25.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_25.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"お通",
            "read":"おつう",
            "introduce":"剣豪と恋に落ちたが、その果てに剣の道を選んだ彼と別の道を歩んでいった。",
            "img":`${_myPath}/meiren/detail/meiren_detail_26.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_26.png`, 
            "img_pifu":`${_myPath}/meiren/detail/meiren_pifu_26.png`, 
            "img_pifu_chongai":`${_myPath}/meiren/detail/meiren_pifuchongai_26.png`
        },
        {
            "name":"斎藤帰蝶",
            "read":"さいとうきちょう",
            "introduce":"戦国時代から安土桃山時代にかけての女性である。美濃国の戦国大名である斎藤道三の娘で、政略結婚で織田信長と結婚した。",
            "img":`${_myPath}/meiren/detail/meiren_detail_27.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_27.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"卓文君",
            "read":"たく・ぶんくん",
            "introduce":"前漢の人。富豪卓王孫の娘。若くして夫に死別し，実家に帰っていたが，そこで文人司馬相如と知りあい，愛しあうようになった。楚調の詩2首は，司馬相如が琴の調べに乗せて卓文君の心を引いたといわれるものだが，後人の擬作であろう。卓文君は恋に生きた中国古代の情熱的な女性の典型として知られる。",
            "img":`${_myPath}/meiren/detail/meiren_detail_28.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_28.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"蔡文姫",
            "read":"さい・ぶんき",
            "introduce":"元は蔡琰で、字は文姫。後漢末期から三国時代の魏にかけての詩人。才女の誉高く、博学かつ弁術に巧みで音律に通じ、数奇な運命を辿った。興平年間董卓の残党のせいで乱が起こると、蔡琰は南匈奴の劉豹に側室として留め置かれた。父と親交のあった曹操のおかげで帰国できた。帰国後、曹操の配慮で同郷出身の董祀に嫁いだ。",
            "img":`${_myPath}/meiren/detail/meiren_detail_29.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_29.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"張春華",
            "read":"ちょう・しゅんか",
            "introduce":"後漢末から魏の人。司馬懿の正室で、諡は穆。夫である司馬懿の諡「宣」を冠して宣穆張皇后の諡号で呼ばれる。司馬懿が曹操に仕え始め、昇進を重ねると、司馬懿は側室を置くようになり、柏夫人を寵愛するようになった。張春華は夫にあまり会わなくなって、59歳で病死した。彼女の棺は洛陽の高原陵に埋葬された。",
            "img":`${_myPath}/meiren/detail/meiren_detail_30.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_30.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"ボルテ",
            "read":"",
            "introduce":"モンゴル帝国の始祖チンギス・カンの第一皇后。コンギラト部族出身。元朝から光献翼聖皇后と諡名される。名はモンゴル部族の始祖として夙に有名な「蒼き狼（ボルテ・チノ）」のボルテと同じで、「灰色のまだら模様」を意味する。",
            "img":`${_myPath}/meiren/detail/meiren_detail_31.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_31.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"阿房女",
            "read":"あぼうじょ",
            "introduce":"邯鄲の人、採藥女中国語の「采药女」。始皇帝は一番愛される王妃のために、阿房宮を作ったそうである。あの王妃のことを阿房女と呼ばれている。",
            "img":`${_myPath}/meiren/detail/meiren_detail_32.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_32.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"衛子夫",
            "read":"えい ・しふ",
            "introduce":"前漢の武帝の皇后。元は武帝の姉である平陽公主家の歌妓であったが、平陽公主に引き立てられ、武帝の後宮に入る。最初に寵愛されることはなく。後宮を離れた際には武帝に目を留められ寵愛を受け、夫人に封じられた。武帝の長男である拠を産んだ後、夫人から皇后に昇格した。",
            "img":`${_myPath}/meiren/detail/meiren_detail_33.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_33.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"李清照",
            "read":"り・せいしょう",
            "introduce":"斉州章丘の人。当時太学の生徒であった3歳年上の夫と結婚する。ところが、母の葬儀のため帰郷の途中、靖康の変が発生して蔵書類は悉く焼かれてしまった。更に臨安の宮廷に召されていた夫が急死、再婚した夫に虐待された末に離別して流浪の生涯を送る中で優れた詞を多く生み出したと言う。",
            "img":`${_myPath}/meiren/detail/meiren_detail_34.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_34.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"紅拂女",
            "read":"こう・ふつじょ",
            "introduce":"風塵三侠の張紅拂と言われる。李靖の愛妻。本名は張出塵。もともとは隋朝の権臣・楊索の侍女。いつも楊索の傍に赤い払子を持って立っていたので、紅拂女と呼ばれるようになった。",
            "img":`${_myPath}/meiren/detail/meiren_detail_35.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_35.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"チセン",
            "read":"ち・せん",
            "introduce":"高平郡金郷の人。郗 鑒の娘、郗愔、郗曇の姉であり“書聖”王 羲之の妻。",
            "img":`${_myPath}/meiren/detail/meiren_detail_36.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_36.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
        {
            "name":"薛霊芸",
            "read":"せつ･れいうん",
            "introduce":"京城一の富豪の娘である。箱入りの娘で、幼い頃よりゲームの主人公と婚約を交わしている。主人公に一筋である。",
            "img":`${_myPath}/meiren/detail/meiren_detail_37.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_37.png`, 
            "img_pifu":`${_myPath}/meiren/detail/meiren_pifu_37.png`, 
            "img_pifu_chongai":`${_myPath}/meiren/detail/meiren_pifuchongai_37.png`
        },
        {
            "name":"孫尚香",
            "read":"そん・しょうこう",
            "introduce":"後漢末期の破虜將軍孫権の妹、姿かたちが整ってうるわしい、才色兼備で気が利く。",
            "img":`${_myPath}/meiren/detail/meiren_detail_38.png`,
            "img_chongai":`${_myPath}/meiren/detail/meiren_chongai_38.png`, 
            "img_pifu":"",
            "img_pifu_chongai":""
        },
    ],
    "suitang":[
        {
            "name":"程知節",
            "read":"てい・ちせつ",
            "introduce":"中国の唐の軍人。姓は程で、名は咬金。瀛州刺史の程婁の子として生まれた。隋の大業末年、人々を集めて郷里の防衛と治安維持にあたった。李密が敗れると秦叔宝とともに唐に帰順し、秦王府左三統軍に任ぜられた。左一馬軍総管を兼領し、先陣を切ったことも幾度かあった。功績により宿国公に封ぜられた。",
            "img":`${_myPath}/suitang/detail/suitang_detail_01.png`,
            "img_pifu":""
        },
        {
            "name":"秦叔宝",
            "read":"しん・しゅくほう",
            "introduce":"中国の唐の軍人。姓は秦で、名は瓊。叔宝とは字であり、字をもって通称される。はじめ隋の将軍の来護児の部将となった。619年、王世充の性格を嫌って、程知節らとともに唐に帰順し、秦王李世民の幕下に属した。功績により翼国公に封ぜられた。",
            "img":`${_myPath}/suitang/detail/suitang_detail_02.png`,
            "img_pifu":""
        },
        {
            "name":"尉遅敬徳",
            "read":"うっち・けいとく",
            "introduce":"尉遅 恭は、中国の唐の軍人。姓は尉遅で、名は恭。墓誌によると、名は融。敬徳は字であり、字をもって通称される。隋の儀同の尉遅伽の子として生まれた。李世民が皇太子となると、敬徳は左衛率に任ぜられ、627年、右武候大将軍に任ぜられ、呉国公に封ぜられ、実封1300戸を受けた。",
            "img":`${_myPath}/suitang/detail/suitang_detail_03.png`,
            "img_pifu":""
        },
        {
            "name":"羅士信",
            "read":"ら・ししん",
            "introduce":"中国の唐の軍人。本貫は斉州歴城。619年に唐に帰順した。高祖李淵により陝州道行軍総管に任じられた。621年、王世充が平定されると、絳州総管となり、郯国公に封ぜられた。622年2月、王君廓に代わって洺州を守り、劉黒闥の襲撃を受けて敗れ、捕らえられたが屈服しなかったため殺された。",
            "img":`${_myPath}/suitang/detail/suitang_detail_04.png`,
            "img_pifu":""
        },
    ],

}
export {roleDetails}